import React, { Component } from 'react'

import { MDBContainer, MDBRow, MDBCol, MDBCard, MDBCardImage, MDBCardBody, MDBCardTitle, MDBCardText, MDBBtn, Button } from 'mdbreact';
import { Card, CardHeader } from 'reactstrap';
import BreadCumb from '../Department/BreadCumb';
import { PostData } from '../../api/service';
import { Container, Typography } from '@material-ui/core';
import BreadCrumbOwn from '../Essentials/BreadCrumbOwn';



// const facultyData = [
//     {
//         name: 'Dr. Jogesh Kakati',
//         desg: 'Principal',
//         qualification: 'MA, PhD',
//         email: '',
//         phone: '',
//         mobile: '',
//         specifications: '',
//         cv: '',
//         photo: ''
//     },

// ]


export default class PrincipalContainer extends Component {

    state = {
        facultyData: [],
        isLoaded: false,
        dept_code: 'OFF'
    }

    componentDidMount() {


        let d = {
            dept_code: 'OFF',
            type: 'PRINCIPAL'
        }

        PostData(`/getemployeebytype`, d)
            .then((resp) => {
                //console.log(resp)
                this.setState({
                    ...resp[0],
                    facultyData: resp,
                    isLoaded: true
                })
            })
    }
    render() {
        return (
            <div>
                <BreadCrumbOwn title="Principal's Message" />


                <Container className='mb-5'>

                    <br />

                    {this.state.isLoaded && this.state.facultyData.map((el, index) => {
                        return <div>
                            {/* <Card style={{ boxShadow: 'none' }}>
                            <CardHeader style={{ color: 'white', boxShadow: 'none', backgroundColor: '#1E3760', textAlign: 'center' }}> <h3 style={{color: 'inherit'}}>{el.desg}</h3></CardHeader>
                        </Card> */}

                            <div>
                               
                                <div>
                                    <Typography variant="h5" style={{ margin: "1em 0", fontWeight: 700 }} gutterBottom>
                                        Principal's Message
                                    </Typography>
                                    <Typography style={{ textAlign: "justify" }} variant="body1" gutterBottom>
                                        It is a matter of utmost privilege and pleasure to extend a warm and heartiest welcome to all the students desiring to take admission in different programs being offered in this premier higher educational institution of the NE region. Pragjyotish College had made its humble beginning, under the initiative of a group of visionary leaders of the region. The college has made exemplary strides from its inception till date. Today, it is not only one of the most distinguished undergraduate co-educational institutions in the entire NE region but is also the college of first choice by many, with programs ranging from higher secondary up to post-graduate. Students from all over the NE region have been nourished here and have excelled in the chosen areas of interests, both in academics as well as extra-curricular accomplishments. The college provides a liberal, lively and competitive environment enabling our learners to carve out a niche for themselves in their respective fields.
                                    </Typography>
                                    <br />

                                    <Typography style={{ textAlign: "justify" }} variant="body1" gutterBottom>
                                        My dear students, the whole world as we know, is facing tremendous challenges in many fronts today, including the education sector. The normal teaching-learning process has been disrupted due to the pandemic COVID-19. In these trying times, we have no other option in our hand, but to switch over to the "online teaching-learning" as well as examination modes. We can express our hope that the pandemic scare will soon cease to have impact on our lives and our society will soon be able to come back to normalcy, thus alleviating the sufferings of all the people. The entire admission process has also necessitated to be switched over to the online mode. Amidst these pandemic times, we braved to assess and accredit our institution through the National Assessment and Accreditation Council for the third consecutive time, which was a challenging task in our hand.
                                    </Typography>
                                    <br />
                                    <Typography style={{ textAlign: "justify" }} variant="body1" gutterBottom>
                                        We believe in all-round development of our students. Apart from academic pursuits, great emphasis is laid on a range of co-curricular activities, discipline and character building of the students. Pragjyotish College has a unique distinction: it has a full-fledged National Cadet Corps (NCC) Unit with four wings-Army, Navy, Air and the Girl's Wings. In addition, the National Service Scheme, Red Ribbon Club, Bharat Scouts and Guides and the Youth Red Cross of the college provides our students a platform and ample opportunities for social involvement.
                                    </Typography>
                                    <br />
                                    <Typography style={{ textAlign: "justify" }} variant="body1" gutterBottom>
                                        With these few words, I once again warmly welcome you to this august institution and pray to the Almighty for resounding success and excellence. I sincerely wish that after admission you not only get actively involved with the corporate life of the college, but also display exemplary excellence in the academic front, thereby embedding your name in the long and glorious list of proud alumni of our college.

                                    </Typography>


                                    <br />
                                    <div>
                                        <div style={{ textAlign: 'right' }}>
                                            <img
                                                alt=""
                                                src={el.dp.length > 0 ? el.dp[0] : ''}
                                                style={{
                                                    width: '250px',
                                                    boxShadow: '1px 2px 10px rgba(0,0,0,0.1)',
                                                    border: `solid 5px wheat`
                                                }}
                                            />
                                        </div>

                                        <h5 style={{ fontSize: '16px', textAlign: 'right', fontWeight: 700 }}>{el.name}</h5>
                                        <h6 style={{ fontSize: '12px', textAlign: 'right' }}><a href={`mailto:${el.email}`}>{el.email}</a></h6>
                                        <h6 style={{ fontSize: '12px', textAlign: 'right' }}><a href={`tel:${el.phone}`}>{el.phone}</a></h6>
                                        <h6 style={{ fontSize: '12px', textAlign: 'right' }}><a href={`tel:${el.mobile}`}>{el.mobile}</a></h6>
                                        <h6 style={{ fontSize: '12px', textAlign: 'right' }}><a href={`tel:${el.mobile}`}>
                                            
                                            
                                            
                                            
                                            {this.state.isLoaded && this.state.id != undefined && <a style={{ color: '#1892FF', cursor: 'pointer', fontWeight: 700, textAlign: "right" }}
                                            
                                            // href={`/department/${this.state.dept_code}/faculty/single?id=${this.state.id}&name=${this.state.name}`}
                                            href={el.cv.length > 0 ? el.cv[0] : ''}
                                            
                                            >Visit Profile</a>}</a></h6>


                                        
                                    </div>

                                </div>


                            </div>
                        </div>

                    })}






                </Container>

            </div>
        )
    }
}